<template>
  <details class="simple" open>
    <summary>Gráfica de ARR</summary>
    <GChart type="BubbleChart" :data="chartData" :options="chartOptions" v-if="items.length" />
    <b-alert v-else variant="info" show> No hay datos suficientes para mostrar la gráfica. </b-alert>
  </details>
</template>
<script>
import { GChart } from "vue-google-charts/legacy";
import { makeBubbleOptions } from "./bubbleChartOptions.js";

function colorPorARR(ARR) {
  if (ARR > 100000) {
    return "> 100k";
  } else if (ARR > 50000) {
    return "> 50k";
  } else {
    return "<= 50k";
  }
}

export default {
  components: {
    GChart,
  },
  props: {
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  computed: {
    chartData() {
      const table = [["Comercial", "Promedio Días Cierre", "ARR", "Nivel ARR", "Ganadas"]];
      this.items.forEach((item) => {
        const color = colorPorARR(item.ARR);
        table.push([item.comercial, item.promedioGanadas, item.ARR, color, item.ganadas]);
      });
      table.sort((a, b) => b[2] - a[2]);
      return table;
    },
  },
  data() {
    return {
      chartOptions: makeBubbleOptions({
        hAxis: { title: "Promedio Días Cierre (solo ganadas)", minValue: 0 },
        vAxis: { title: "ARR", minValue: 0 },
        series: {
          "> 100k": { color: "#2ecc71" },
          "> 50k": { color: "#f1c40f" },
          "<= 50k": { color: "#e74c3c" },
        },
      }),
    };
  },
};
</script>
